import React, { Component } from 'react';

class CategoryButton extends Component {
  render() {

    let logo = this.props.logo;
    let name = this.props.name;

    return (
          <div className="category-button">
            <img className="category-button-icon" src={logo} alt={name} />
            <h3>{name}</h3>
          </div>
    );
  }
}

export default CategoryButton;
